/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable require-yield */
import { takeLatest, put, call } from 'redux-saga/effects';
import { login, setCurrentUser, setAuthError, setAuth } from './authSlice';
import { loginUser } from '../../utils/apiCalls';
import { formatApiError } from '../../utils/apiErrors';
export interface ResponseUserData {
  email: string;
  id: string;
  isActivated: boolean;
  isDeleted: boolean;
  isPrivacyPolicyAgree: boolean;
  isTermsAgree: boolean;
  name: string;
  ninoxId: number;
  role: number;
  token: string;
}
export interface ResponseData {
  data: ResponseUserData | null;
  status: number;
  statusText: string;
}

function* loginSaga(action: any) {
  try {
    const user: any = {
      email: action.payload.username,
      password: action.payload.password,
      stayLoggedIn: true,
    };
    const res: ResponseData = yield call(loginUser, user);
    if (res?.status === 200 && res.data?.token) {
      yield put(setAuth(res.data.token));
      yield put(setAuthError(null));
      yield put(setCurrentUser(res.data));
    } else {
      yield put(setAuthError(formatApiError(res)));
    }
  } catch (err) {
    yield put(setAuthError(formatApiError(err)));
    // eslint-disable-next-line no-console
    console.error('New error', err);
  }
}

export function* watchAuthSaga() {
  yield takeLatest(login.type, loginSaga);
}
